'use client';

var translations = {
    'Sign in to continue': 'Đăng nhập để tiếp tục',
    'or with your email': 'hoặc đăng nhập bằng email',
    'Forgot Password?': 'Quên mật khẩu?',
    Email: 'Email',
    Password: 'Mật khẩu',
    'with Facebook account': 'với tài khoản Facebook',
    'with Google account': 'với tài khoản Google',
    Login: 'Đăng nhập',
    "Don't have an account yet?": 'Chưa có tài khoản?',
    'Register now': 'Đăng Ký',
    'The Email field is required.': 'Vui lòng nhập Email',
    'The Password field is required.': 'Vui lòng nhập Mật Khẩu',
    'The Email must be a valid Email address.': 'Email không hợp lệ.',
    'Wrong email or password. Please check again.': 'Email hoặc mật khẩu không đúng. Hãy kiểm tra lại.',
    'You have not verified your email. Please check your email inbox for instruction.': 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.',
    'This email address is registered as Employer, please Sign in from Employer Site.': 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.',
    'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.': 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
